import { render, staticRenderFns } from "./MatchHero.vue?vue&type=template&id=639dc8d5&scoped=true"
import script from "./MatchHero.vue?vue&type=script&lang=js"
export * from "./MatchHero.vue?vue&type=script&lang=js"
import style0 from "./MatchHero.vue?vue&type=style&index=0&id=639dc8d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639dc8d5",
  null
  
)

export default component.exports